module.exports = __webpack_public_path__ + "static/media/OPYN-logo.6c405c3b.png";